import { render, staticRenderFns } from "./notice_add.vue?vue&type=template&id=e97636a8&scoped=true"
import script from "./notice_add.vue?vue&type=script&lang=js"
export * from "./notice_add.vue?vue&type=script&lang=js"
import style0 from "./notice_add.vue?vue&type=style&index=0&id=e97636a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97636a8",
  null
  
)

export default component.exports